import { render, staticRenderFns } from "./systemTransPriceRecordformation.vue?vue&type=template&id=00ffa38c&scoped=true&"
import script from "./systemTransPriceRecordformation.vue?vue&type=script&lang=js&"
export * from "./systemTransPriceRecordformation.vue?vue&type=script&lang=js&"
import style0 from "./systemTransPriceRecordformation.vue?vue&type=style&index=0&id=00ffa38c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ffa38c",
  null
  
)

export default component.exports